import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = Cookies.get('cookie_consent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set('cookie_consent', 'true', { expires: 365 });
    setShow(false);
  };

  const handleDecline = () => {
    window.location.href = 'https://www.google.com/';
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#333',
      color: '#fff',
      padding: '20px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <span>
        Utilizamos cookies e coletamos dados pessoais. Ao continuar navegando, você concorda com nossa{' '}
        <Link to="/politica-e-termos" style={{ color: '#66b2ff', textDecoration: 'underline' }}>
          Política de Privacidade e Termos de Uso
        </Link>.
      </span>

      <div style={{ marginTop: 10 }}>
        <Button variant="secondary" onClick={handleDecline} style={{ marginRight: '10px' }}>
          Recusar
        </Button>
        <Button variant="primary" onClick={handleAccept}>
          Concordo
        </Button>
      </div>
    </div>
  );
}
